import React, {
  useEffect, useState
} from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export const DescriptionComponents = ({
  parentTranslationPath,
  setDescription,
  enDescription,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const [state, setState] = useState({
    englishDescription: ''
  });

  useEffect(() => {
    if (enDescription || (state.englishDescription === undefined)) {
      setState({
        englishDescription: enDescription
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enDescription]);

  useEffect(() => {
    setDescription(state);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);
  return (
    <div className='view-wrapper-AddFormCountry'>
      <div className='w-100 ReactQuill-wrpaer'>
        <div className='pt-3'>
          <span className='label-wrapper'>{t('English-description')}</span>
          <ReactQuill
            idRef='englishDescription'
            placeholder={t('TypeHere')}
            value={state.englishDescription || ''}
            onChange={(event) =>
              setState({ ...state, englishDescription: event })}
          />
        </div>
      </div>
    </div>

  );
};

DescriptionComponents.propTypes = {
  parentTranslationPath: PropTypes.string.isRequired,
  translationPath: PropTypes.string.isRequired,
  setDescription: PropTypes.func.isRequired,
};
